import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ClientLocationsMap } from './client_locations_map';
import { getDistrictContactsTitle } from './district_contact_title';
import { FireRequestsHomepage } from './fire_requests_homepage';

export const Home = () => {
  const currentUser = (() => {
    try { return JSON.parse(sessionStorage.getItem('currentUser')); } catch (error) { return null; }
  })();
  const isFire = currentUser?.portalApp === 'fire_pest' && !currentUser?.isAdmin;
  const dispatch = useDispatch();
  const [districts, setDistricts] = useState([]);
  const [contactsTitle, setContactsTitle] = useState('Contacts');
  const [showDistrictContacts, setShowDistrictContacts] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isFire) return undefined;
    let cancelled = false;
    fetch('/apidistricts').then(async response => {
      const records = await response.json();
      if (cancelled) return;
      if (records && records.sessionExpired) {
        dispatch({ type: 'LOG_OUT', payload: null });
        sessionStorage.removeItem('currentUser');
        window.location = '/';
      } else if (response.ok) {
        setDistricts(records);
        const contactsVisible = response.headers?.get('X-District-Contacts-Visible') === 'true';
        setShowDistrictContacts(contactsVisible);
        if (contactsVisible) setContactsTitle(getDistrictContactsTitle(records));
      }
    });
    return () => { cancelled = true; };
  }, [dispatch, isFire]);

  const redirectToDistrictPage = (e, districtCode) => {
    navigate(`district/${districtCode}`, {state: {id: districtCode}});
  }

  if (isFire) return <FireRequestsHomepage />;

  return (
    <div className="homepage">
      <div className="dashboardWelcome">
        <div><h2>Locations</h2></div>
      </div>
      <ClientLocationsMap />
      {showDistrictContacts && <section className="dashboardTableCard">
      <div className="dashboardTableHeader"><h2>{contactsTitle}</h2><p>Select a district to view contact details and schedules.</p></div>
      <div className="tableScroll"><table id="tableWrapper">
        <tbody>
        <tr>
          <th>District Full Name</th>
          <th>Label</th>
          {/* <th>Email District Schedules Excel</th>
          <th>Email District Schedules Word</th> */}
          <th>{contactsTitle} - Name</th>
          <th>{contactsTitle} - Phone</th>
          <th>{contactsTitle} - Email</th>
        </tr>
          {districts && districts.length > 0 && districts.map((district, idx) => {
            const districtCode = district && district[6].value ? district[6].value : null;
            return (
              <tr key={idx} onClick={(e) => redirectToDistrictPage(e, districtCode)} className="tableRow">
                <td className="tableCell">{district && district[21] ? district[21].value : ""}</td>
                <td className="tableCell">{district && district[11] ? district[11].value : ""}</td>
                {/* <td className="tableCell">{"Download Pick Up Schedules Excel"}</td>
                <td className="tableCell">{"Download Pick Up Schuedles Word"}</td> */}
                <td className="tableCell">{district && district[28] ? district[28].value : ""}</td>
                <td className="tableCell">{district && district[30] ? district[30].value : ""}</td>
                <td className="tableCell">{district && district[33] ? district[33].value : ""}</td>
              </tr>
            )
          })}
          </tbody>
      </table></div>
      </section>}
    </div>
  )
}
